<template>
  <a-modal title="详情" :visible="showTubeView" :width="800" destroyOnClose @ok="handleOk" @cancel="closeTubeView">
    <a-modal
      title="地图"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref="lonlatMaps" @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
    <a-row style="margin-top: 20px">
      <a-col :span="12">任务名称：{{ addOrUpda.taskName }}</a-col>
      <a-col :span="12">负责人: {{ addOrUpda.principalName }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">巡检泵房: {{ addOrUpda.pumpName }}</a-col>
      <a-col :span="12">巡检周期: {{ addOrUpda.inspectionFrequency }}</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">上次巡检时间：{{ addOrUpda.lastInspectionDate }}</a-col>
      <a-col :span="12">预期处理时长: {{ addOrUpda.planTime }}天</a-col>
    </a-row>
    <a-row style="margin-top: 20px">
      <a-col :span="12">下次巡检时间：{{ addOrUpda.nextInspectionDate }}</a-col>
      <a-col :span="12">任务描述：{{ addOrUpda.description }}</a-col>
    </a-row>
    <!-- <a-form-model
      class="log-form"
      :model="addOrUpdateForm"
      ref="addOrUpdateForm"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 14 }"
    >
      <a-row class="form-row" type="flex" justify="center" :gutter="4">
        <a-col :md="12" :sm="24">
          <a-form-model-item label="巡检事项">{{ addOrUpdateForm.inspectionItems }}</a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="负责人">{{ addOrUpdateForm.principalName }}</a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="协办人" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">{{
            addOrUpdateForm.assistPersonName
          }}</a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="开始时间">{{ addOrUpdateForm.startTime }}</a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="任务周期">{{ addOrUpdateForm.inspectionFrequency }}</a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="周期次数">{{ addOrUpdateForm.numberOfInspections }}</a-form-model-item>
        </a-col>
        <a-col :md="12" :sm="24">
          <a-form-model-item label="片区">{{ addOrUpdateForm.zoneName }}</a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="位置" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-button type="primary" @click="addAddress">查看位置</a-button>
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">{{
            addOrUpdateForm.address
          }}</a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="任务描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">{{
            addOrUpdateForm.description
          }}</a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-form-model-item label="任务记录" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-table
              rowKey="id"
              bordered
              :scroll="{ y: 180 }"
              :data-source="addOrUpdateForm.taskPollingRecords"
              :columns="columns"
            ></a-table>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model> -->
  </a-modal>
</template>
<script>
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
export default {
  components: {
    addModal,
    LonlatMap,
  },
  props: {},
  data() {
    return {
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '任务编号',
          dataIndex: 'taskNumber',
        },
        {
          title: '开始时间',
          dataIndex: 'startTime',
        },
        {
          title: '完成时间',
          dataIndex: 'completeTime',
        },
        {
          title: '处理时长',
          dataIndex: 'processingTime',
        },
      ],
      queryOneUrl: '/pipe-network/inspection_managements',
      showTubeView: false,
      id: '',
      addOrUpdateForm: {
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principalName: '',
      },
      addOrUpda: {},
      eventTypeList: [],
      assistPersonsList: [],
      currentId: '',
      mapVisible: false,
    }
  },
  computed: {
    rules() {
      return {}
    },
  },
  created() {},
  methods: {
    moment,
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleOk(e) {
      e.preventDefault()
      this.closeTubeView()
    },
    _updateForm(real, data) {
      let keys = Object.keys(real)
      let dataKeys = Object.keys(data)
      let newObject = {}
      keys.map((key) => {
        if (dataKeys.includes(key)) {
          newObject[key] = data[key]
        } else {
          newObject[key] = real[key]
        }
      })
      return newObject
    },
    edit(id) {
      this.showTubeView = true
      this.currentId = id

      this.$nextTick(() => {
        if (id) {
          this.isUpdate = true
          this.$http.get(`${this.queryOneUrl}/${this.currentId}`).then(({ data }) => {
            
            // this.addOrUpdateForm = { ...this._updateForm(this.addOrUpdateForm, data) }
            this.addOrUpda = data
            console.log(this.addOrUpda, 'hhhhhhh')
            this.addOrUpdateForm = data
          })
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.assistPersonsList = []
    },
    addAddress() {
      this.mapVisible = true
      if (this.addOrUpdateForm.place) {
        var pointData = this.addOrUpdateForm.place.split(',')
        var newPointData = pointData.map((item) => {
          return (item = parseFloat(item))
        })
        console.log(newPointData, this.$refs) // [113.678351, 25.538859]
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint(newPointData)
        })
      } else {
        this.$nextTick(() => {
          this.$refs.lonlatMaps.changepoint([0, 0])
        })
      }
    },
    handleMapOk() {},
  },
}
</script>

<style lang="less" scoped>
</style>
